export const LAWN_ROBOT_CATEGORY = "Robotas";

export const LAWN_ROBOT_BRANDS = [
  {
    name: "DCK",
    extraInfoType: "dck",
    models: ["E305", "E308", "KDRM220", "S2000"],
  },
  {
    name: "DREAME MOVA",
    extraInfoType: "mova",
    allowCustomModel: true,
    models: [],
  },
  {
    name: "Ecovacs",
    models: ["A1600 LIDAR PRO", "A3000 LIDAR PRO", "O1200 LIDAR PRO"],
  },
  {
    name: "Lymow",
    models: ["One PLUS"],
  },
  {
    name: "Roborock",
    models: ["Q105", "Q110", "S108", "S115", "Z115", "Z120", "Z130", "Z150"],
  },
  {
    name: "Segway Navimow",
    extraInfoType: "segway",
    models: [
      "H215 LIDAR",
      "H230 LIDAR",
      "h206 LIDAR",
      "h210 LIDAR",
      "i105",
      "i108",
      "i206 AWD nRTK",
      "i208 AWD nRTK",
      "i208 LIDAR",
      "i210 AWD nRTK",
      "i210 LIDAR",
      "i210 LIDAR PRO AWD",
      "i215 LIDAR",
      "i220 LIDAR",
      "i220 LIDAR PRO AWD",
      "Terranox 1.2ha",
      "Terranox 2,4ha",
      "X315",
      "X330",
      "X350",
      "X390",
      "X420",
      "X430",
      "X450",
    ],
  },
  {
    name: "Sunseeker",
    extraInfoType: "sunseeker",
    models: ["X4", "x5 GEN2", "X7 Gen2", "X7 PLUS Gen2", "X9", "X9 PLUS"],
  },
  {
    name: "Terramow",
    extraInfoType: "terramow",
    models: ["S800", "S1200", "V600", "V1000"],
  },
].sort((a, b) => a.name.localeCompare(b.name, "lt", { sensitivity: "base" }));

export const getLawnRobotBrand = (brand = "") =>
  LAWN_ROBOT_BRANDS.find(
    (item) => item.name.toLowerCase() === String(brand).toLowerCase()
  );

export const getLawnRobotModels = (brand = "") => {
  const selectedBrand = getLawnRobotBrand(brand);
  return selectedBrand?.models || [];
};

export const brandAllowsCustomModel = (brand = "") =>
  Boolean(getLawnRobotBrand(brand)?.allowCustomModel);

export const getRobotExtraInfoType = (category = "", brand = "") => {
  if (category !== LAWN_ROBOT_CATEGORY) return null;
  return getLawnRobotBrand(brand)?.extraInfoType || null;
};
